import React from "react";

const ForbiddenIcon = ({ className, color }) => {
  return (
    <svg
      className={className}
      fill={color || "#000000"}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        <path d="M8 .5A7.77 7.77 0 0 0 0 8a7.77 7.77 0 0 0 8 7.5A7.77 7.77 0 0 0 16 8 7.77 7.77 0 0 0 8 .5zM1.25 8A6 6 0 0 1 3 3.85L12.09 13A7.12 7.12 0 0 1 8 14.25 6.52 6.52 0 0 1 1.25 8zM13 12.15 3.91 3A7.12 7.12 0 0 1 8 1.75 6.52 6.52 0 0 1 14.75 8 6 6 0 0 1 13 12.15z"></path>
      </g>
    </svg>
  );
};

export default ForbiddenIcon;
